/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Credentials} from '../models/Credentials';
import type {CredentialsUpdateResult} from '../models/CredentialsUpdateResult';
import type {Error} from '../models/Error';
import type {SalesforceAccountSettings} from '../models/SalesforceAccountSettings';
import type {SalesforceCredentials} from '../models/SalesforceCredentials';

export interface CheckSalesforceCredentials$Request {
    accountId: number;
    salesforceCredentials: SalesforceCredentials;
}

export interface CheckSalesforceCredentials$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const checkSalesforceCredentialsRequest = createAction<PayloadData<void, CheckSalesforceCredentials$Request>>('SALESFORCE_CONTROLLER__CHECK_SALESFORCE_CREDENTIALS__REQUEST');
export const checkSalesforceCredentialsSuccess = createAction<PayloadData<CredentialsUpdateResult, CheckSalesforceCredentials$Request>>('SALESFORCE_CONTROLLER__CHECK_SALESFORCE_CREDENTIALS__SUCCESS');
export const checkSalesforceCredentialsFailure = createAction<PayloadData<Error, CheckSalesforceCredentials$Request, true>>('SALESFORCE_CONTROLLER__CHECK_SALESFORCE_CREDENTIALS__FAILURE');

export const checkSalesforceCredentialsActions = [
    checkSalesforceCredentialsRequest,
    checkSalesforceCredentialsSuccess,
    checkSalesforceCredentialsFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {SalesforceCredentials} meta.salesforceCredentials
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const checkSalesforceCredentials = (meta: CheckSalesforceCredentials$Request, config?: CheckSalesforceCredentials$Config) => {
    return {
        CALL_API: {
            types: checkSalesforceCredentialsActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/crm/${meta.accountId}/salesforce/credentials-check`,
            TRANSPORT_REQUEST_BODY: meta.salesforceCredentials,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface CleanupOAuthCredentials$Request {
    accountId: number;
}

export interface CleanupOAuthCredentials$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const cleanupOAuthCredentialsRequest = createAction<PayloadData<void, CleanupOAuthCredentials$Request>>('SALESFORCE_CONTROLLER__CLEANUP_O_AUTH_CREDENTIALS__REQUEST');
export const cleanupOAuthCredentialsSuccess = createAction<PayloadData<void, CleanupOAuthCredentials$Request>>('SALESFORCE_CONTROLLER__CLEANUP_O_AUTH_CREDENTIALS__SUCCESS');
export const cleanupOAuthCredentialsFailure = createAction<PayloadData<Error, CleanupOAuthCredentials$Request, true>>('SALESFORCE_CONTROLLER__CLEANUP_O_AUTH_CREDENTIALS__FAILURE');

export const cleanupOAuthCredentialsActions = [
    cleanupOAuthCredentialsRequest,
    cleanupOAuthCredentialsSuccess,
    cleanupOAuthCredentialsFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const cleanupOAuthCredentials = (meta: CleanupOAuthCredentials$Request, config?: CleanupOAuthCredentials$Config) => {
    return {
        CALL_API: {
            types: cleanupOAuthCredentialsActions,
            method: ApiMethods.DELETE,
            endpoint: `/web-api/crm/${meta.accountId}/salesforce/credentials`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetSalesforceCredentials$Request {
    accountId: number;
}

export interface GetSalesforceCredentials$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getSalesforceCredentialsRequest = createAction<PayloadData<void, GetSalesforceCredentials$Request>>('SALESFORCE_CONTROLLER__GET_SALESFORCE_CREDENTIALS__REQUEST');
export const getSalesforceCredentialsSuccess = createAction<PayloadData<SalesforceCredentials, GetSalesforceCredentials$Request>>('SALESFORCE_CONTROLLER__GET_SALESFORCE_CREDENTIALS__SUCCESS');
export const getSalesforceCredentialsFailure = createAction<PayloadData<Error, GetSalesforceCredentials$Request, true>>('SALESFORCE_CONTROLLER__GET_SALESFORCE_CREDENTIALS__FAILURE');

export const getSalesforceCredentialsActions = [
    getSalesforceCredentialsRequest,
    getSalesforceCredentialsSuccess,
    getSalesforceCredentialsFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getSalesforceCredentials = (meta: GetSalesforceCredentials$Request, config?: GetSalesforceCredentials$Config) => {
    return {
        CALL_API: {
            types: getSalesforceCredentialsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/crm/${meta.accountId}/salesforce/credentials`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetSalesforceCredentialsOauth$Request {
    accountId: number;
    sandBox?: boolean;
}

export interface GetSalesforceCredentialsOauth$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getSalesforceCredentialsOauthRequest = createAction<PayloadData<void, GetSalesforceCredentialsOauth$Request>>('SALESFORCE_CONTROLLER__GET_SALESFORCE_CREDENTIALS_OAUTH__REQUEST');
export const getSalesforceCredentialsOauthSuccess = createAction<PayloadData<Credentials, GetSalesforceCredentialsOauth$Request>>('SALESFORCE_CONTROLLER__GET_SALESFORCE_CREDENTIALS_OAUTH__SUCCESS');
export const getSalesforceCredentialsOauthFailure = createAction<PayloadData<Error, GetSalesforceCredentialsOauth$Request, true>>('SALESFORCE_CONTROLLER__GET_SALESFORCE_CREDENTIALS_OAUTH__FAILURE');

export const getSalesforceCredentialsOauthActions = [
    getSalesforceCredentialsOauthRequest,
    getSalesforceCredentialsOauthSuccess,
    getSalesforceCredentialsOauthFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {boolean} [meta.sandBox]
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getSalesforceCredentialsOauth = (meta: GetSalesforceCredentialsOauth$Request, config?: GetSalesforceCredentialsOauth$Config) => {
    const TRANSPORT_GET_PARAMS = {
        sandBox: meta.sandBox,
    };
    return {
        CALL_API: {
            types: getSalesforceCredentialsOauthActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/crm/${meta.accountId}/salesforce/credentials-oauth`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetSalesforceCrmSettings$Request {
    accountId: number;
}

export interface GetSalesforceCrmSettings$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getSalesforceCrmSettingsRequest = createAction<PayloadData<void, GetSalesforceCrmSettings$Request>>('SALESFORCE_CONTROLLER__GET_SALESFORCE_CRM_SETTINGS__REQUEST');
export const getSalesforceCrmSettingsSuccess = createAction<PayloadData<SalesforceAccountSettings, GetSalesforceCrmSettings$Request>>('SALESFORCE_CONTROLLER__GET_SALESFORCE_CRM_SETTINGS__SUCCESS');
export const getSalesforceCrmSettingsFailure = createAction<PayloadData<Error, GetSalesforceCrmSettings$Request, true>>('SALESFORCE_CONTROLLER__GET_SALESFORCE_CRM_SETTINGS__FAILURE');

export const getSalesforceCrmSettingsActions = [
    getSalesforceCrmSettingsRequest,
    getSalesforceCrmSettingsSuccess,
    getSalesforceCrmSettingsFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getSalesforceCrmSettings = (meta: GetSalesforceCrmSettings$Request, config?: GetSalesforceCrmSettings$Config) => {
    return {
        CALL_API: {
            types: getSalesforceCrmSettingsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/crm/${meta.accountId}/salesforce/settings`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface ObtainAndSaveAuthCredentials$Request {
    accountId: number;
    sandBox?: boolean;
    codeVerifier?: string;
    body?: string;
}

export interface ObtainAndSaveAuthCredentials$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const obtainAndSaveAuthCredentialsRequest = createAction<PayloadData<void, ObtainAndSaveAuthCredentials$Request>>('SALESFORCE_CONTROLLER__OBTAIN_AND_SAVE_AUTH_CREDENTIALS__REQUEST');
export const obtainAndSaveAuthCredentialsSuccess = createAction<PayloadData<CredentialsUpdateResult, ObtainAndSaveAuthCredentials$Request>>('SALESFORCE_CONTROLLER__OBTAIN_AND_SAVE_AUTH_CREDENTIALS__SUCCESS');
export const obtainAndSaveAuthCredentialsFailure = createAction<PayloadData<Error, ObtainAndSaveAuthCredentials$Request, true>>('SALESFORCE_CONTROLLER__OBTAIN_AND_SAVE_AUTH_CREDENTIALS__FAILURE');

export const obtainAndSaveAuthCredentialsActions = [
    obtainAndSaveAuthCredentialsRequest,
    obtainAndSaveAuthCredentialsSuccess,
    obtainAndSaveAuthCredentialsFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {boolean} [meta.sandBox]
 * @param {string} [meta.codeVerifier]
 * @param {string} [meta.body]
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const obtainAndSaveAuthCredentials = (meta: ObtainAndSaveAuthCredentials$Request, config?: ObtainAndSaveAuthCredentials$Config) => {
    const TRANSPORT_GET_PARAMS = {
        sandBox: meta.sandBox,
        codeVerifier: meta.codeVerifier,
    };
    return {
        CALL_API: {
            types: obtainAndSaveAuthCredentialsActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/crm/${meta.accountId}/salesforce/credentials-oauth`,
            TRANSPORT_GET_PARAMS,
            TRANSPORT_REQUEST_BODY: meta.body,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface SaveSalesforceCredentials$Request {
    accountId: number;
    salesforceCredentials: SalesforceCredentials;
}

export interface SaveSalesforceCredentials$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const saveSalesforceCredentialsRequest = createAction<PayloadData<void, SaveSalesforceCredentials$Request>>('SALESFORCE_CONTROLLER__SAVE_SALESFORCE_CREDENTIALS__REQUEST');
export const saveSalesforceCredentialsSuccess = createAction<PayloadData<CredentialsUpdateResult, SaveSalesforceCredentials$Request>>('SALESFORCE_CONTROLLER__SAVE_SALESFORCE_CREDENTIALS__SUCCESS');
export const saveSalesforceCredentialsFailure = createAction<PayloadData<Error, SaveSalesforceCredentials$Request, true>>('SALESFORCE_CONTROLLER__SAVE_SALESFORCE_CREDENTIALS__FAILURE');

export const saveSalesforceCredentialsActions = [
    saveSalesforceCredentialsRequest,
    saveSalesforceCredentialsSuccess,
    saveSalesforceCredentialsFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {SalesforceCredentials} meta.salesforceCredentials
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const saveSalesforceCredentials = (meta: SaveSalesforceCredentials$Request, config?: SaveSalesforceCredentials$Config) => {
    return {
        CALL_API: {
            types: saveSalesforceCredentialsActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/crm/${meta.accountId}/salesforce/credentials`,
            TRANSPORT_REQUEST_BODY: meta.salesforceCredentials,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface SaveSalesforceCrmSettings$Request {
    accountId: number;
    salesforceAccountSettings?: SalesforceAccountSettings;
}

export interface SaveSalesforceCrmSettings$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const saveSalesforceCrmSettingsRequest = createAction<PayloadData<void, SaveSalesforceCrmSettings$Request>>('SALESFORCE_CONTROLLER__SAVE_SALESFORCE_CRM_SETTINGS__REQUEST');
export const saveSalesforceCrmSettingsSuccess = createAction<PayloadData<void, SaveSalesforceCrmSettings$Request>>('SALESFORCE_CONTROLLER__SAVE_SALESFORCE_CRM_SETTINGS__SUCCESS');
export const saveSalesforceCrmSettingsFailure = createAction<PayloadData<Error, SaveSalesforceCrmSettings$Request, true>>('SALESFORCE_CONTROLLER__SAVE_SALESFORCE_CRM_SETTINGS__FAILURE');

export const saveSalesforceCrmSettingsActions = [
    saveSalesforceCrmSettingsRequest,
    saveSalesforceCrmSettingsSuccess,
    saveSalesforceCrmSettingsFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {SalesforceAccountSettings} [meta.salesforceAccountSettings]
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const saveSalesforceCrmSettings = (meta: SaveSalesforceCrmSettings$Request, config?: SaveSalesforceCrmSettings$Config) => {
    return {
        CALL_API: {
            types: saveSalesforceCrmSettingsActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/crm/${meta.accountId}/salesforce/settings`,
            TRANSPORT_REQUEST_BODY: meta.salesforceAccountSettings,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface UnlinkSalesforceOrgId$Request {
    accountId: number;
}

export interface UnlinkSalesforceOrgId$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const unlinkSalesforceOrgIdRequest = createAction<PayloadData<void, UnlinkSalesforceOrgId$Request>>('SALESFORCE_CONTROLLER__UNLINK_SALESFORCE_ORG_ID__REQUEST');
export const unlinkSalesforceOrgIdSuccess = createAction<PayloadData<void, UnlinkSalesforceOrgId$Request>>('SALESFORCE_CONTROLLER__UNLINK_SALESFORCE_ORG_ID__SUCCESS');
export const unlinkSalesforceOrgIdFailure = createAction<PayloadData<Error, UnlinkSalesforceOrgId$Request, true>>('SALESFORCE_CONTROLLER__UNLINK_SALESFORCE_ORG_ID__FAILURE');

export const unlinkSalesforceOrgIdActions = [
    unlinkSalesforceOrgIdRequest,
    unlinkSalesforceOrgIdSuccess,
    unlinkSalesforceOrgIdFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const unlinkSalesforceOrgId = (meta: UnlinkSalesforceOrgId$Request, config?: UnlinkSalesforceOrgId$Config) => {
    return {
        CALL_API: {
            types: unlinkSalesforceOrgIdActions,
            method: ApiMethods.DELETE,
            endpoint: `/web-api/crm/${meta.accountId}/salesforce/org-ids`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

